import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const cancelledOrdersIcon = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.33594 2.5V0.5H5.33594V2.5H1.33594C0.783657 2.5 0.335938 2.94772 0.335938 3.5V19.5C0.335938 20.0523 0.783657 20.5 1.33594 20.5H19.3359C19.8882 20.5 20.3359 20.0523 20.3359 19.5V3.5C20.3359 2.94772 19.8882 2.5 19.3359 2.5H15.3359V0.5H13.3359V2.5H7.33594ZM2.33594 9.5H18.3359V18.5H2.33594V9.5ZM2.33594 4.5H5.33594V5.5H7.33594V4.5H13.3359V5.5H15.3359V4.5H18.3359V7.5H2.33594V4.5ZM8.21456 10.4644L10.3359 12.5858L12.4571 10.4644L13.8714 11.8785L11.7501 14.0001L13.8713 16.1212L12.4572 17.5354L10.3359 15.4143L8.21449 17.5354L6.80036 16.1211L8.92164 14.0001L6.8003 11.8785L8.21456 10.4644Z"
      fill="#F26533"
    />
  </svg>
);

export const CancelledOrdersIcon = (
  props: Partial<CustomIconComponentProps>
) => <Icon component={cancelledOrdersIcon} {...props} />;
